var vms = vms || {};
/*Watch related functions*/
vms.watch = vms.watch || {};
var watchRow, watchDeleteIds = [], watchCrew, watchTemplates;
vms.watch = {
	setTemplate: function (pIndex, pThis) {
		var vIndex = pIndex;
		if (pThis) {
			for (var i = 0; i < watchTemplates.length; i++) {
				if (watchTemplates[i].id == pIndex)
					vIndex = i;
			}
		}
		var vCnt = 0, vHours = watchTemplates[vIndex].hrs;
		var $vRow = $(pThis).closest("tr")
		$vRow.find(".shiftHrsItem > div").each(function (index) {
			if (vHours.substring(index, index + 1) == "Y") {
				$(this).addClass("selected");
				vCnt++;
			} else $(this).removeClass("selected");
		});
		$vRow.find(".hrsCnt > span").text(vCnt / 4);
		$vRow.find("input[name=hours]").val(vHours);
		$vRow.find("input[name=hours_tmp]").val(watchTemplates[vIndex].id);
		$vRow.attr("pid", watchTemplates[vIndex].parent);
		vms.btn.hightlight("watchSubmitBtn");
	},
	showTemplates: function (pThis) {
		var $item = $(pThis);
		var $ul = $item.find(".shiftTemplateDrop");
		var vParent = $item.closest("tbody").attr("pid");
		if ($ul.find("li").length == 0) {
			for (var i = 0; i < watchTemplates.length; i++) {
				if (watchTemplates[i].parent == vParent)
					$ul.append('<li onclick="vms.watch.setTemplate(' + i + ',this)">' + watchTemplates[i].name + '</li>');
			}
		}
	},
	form: function (pDateSelector) {
		apex.server.process("watchForm"
			, { x01: $v("watchProjectId"), x02: $v(pDateSelector), x03: $v("watchSchemaId"), x04: $v("watchTemplateId") }
			, {
				dataType: "html",
				success: function (pData) {
					$(".watchForm").html(pData);
					vms.btn.unhightlight("watchSubmitBtn");
					watchDeleteIds = [];
				}
			});
	},	
	check: function () {
		var vMsg = "", vHrs, vCrewOverlap = [];
		//if ($("tr.primary select[name=assigned]").filter(function () { return !$(this).val(); }).length > 0) vMsg = "Please assign crew members to all OOW shifts! ";
		for (x = 0; x < watchCrew.length; x++) {
			vHrs = 'NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN';
			$("tr select[name=assigned]").filter(function () { return $(this).val() == watchCrew[x].id; }).each(function () {
				vHrs = vms.watch.appendHours(vHrs, $(this).closest("tr").find("input[name=hours]").val());
			});
			if (vHrs.indexOf('O') > -1) {
				vCrewOverlap.push(watchCrew[x].name);
			}
		}
		if (vCrewOverlap.length > 0) vMsg += "Following crew members have multiple shifts with overlaping hours: " + vCrewOverlap.join(", ");
		return vMsg;
	},	
	submit: function () {
		var vOverlap, vRow, vRows = [], vData, vSchemaId = $("#watchSchemaId").val();
		var vMsg = vms.watch.check();
		if (vMsg)
			alert(vMsg);
		else {
			$(".watchForm > table > tbody > tr:not(.primaryHdr)").each(function () {
				if ($(this).find("select[name=assigned]").length > 0) {
					vRow = $(this).find("input[name=id]").val().replace("|", "").replace("~", "") + '|'
						+ $(this).find("select[name=assigned]").val() + '|'
						+ $(this).find("select[name=backup]").val() + '|'
						+ $(this).find("input[name=hours]").val() + '|'
						+ $(this).find("input[name=oow_eow]").val() + '|'
						+ $(this).find("input[name=hours_tmp]").val() + '|'
						+ $(this).attr("pid");
					vRows.push(vRow);
				}
			});
			vData = vRows.join("~");
			apex.server.process("watchSubmit"
				, { x01: $v("watchProjectId"), x02: $v("watchDate"), x03: vData, x04: watchDeleteIds.join(":"), x05: $v("watchProjectOwner") }
				, {
					dataType: "html",
					success: function (pData) {
						if ($(pData).find(".watchForm")) $(".watchForm").replaceWith(pData);
						vms.btn.unhightlight("watchSubmitBtn");
						watchDeleteIds = [];
						$("select[name='assigned']").select2();
						$("select[name='backup']").select2();
					}
				});
		}
	},
	replicate: function () {
		var vMsg = vms.watch.check();
		if (vMsg)
			alert(vMsg);
		else {
			if (confirm("Are you sure you want to apply this watch setup to rest of the days of this voyage?")) {
				apex.server.process("watchReplicate"
					, { x01: $v("watchProjectId"), x02: $v("watchDate") }
					, {
						dataType: "html",
						success: function (pData) {
							alert("Watch setup applied to rest of the days of this voyage!");
						}
					});
			}
		}
	},
	statistic: function () {
		var vPopup = "", vHrs;
		for (x = 0; x < watchCrew.length; x++) {
			vHrs = 0;
			$("tr [name=assigned]").filter(function () { return $(this).val() == watchCrew[x].id; }).each(function () {
				vHrs += Number($(this).closest("tr").find(".hrsCnt > span").text());
			});
			vPopup += "<tr" + ((vHrs == 0) ? ' class="red"' : '') + "><td>" + watchCrew[x].name + "</td><td>" + vHrs + "</td></tr>";
		}
		$("body").append('<div class="vsmPopup watchStatistic" onclick="$(this).remove();"><div class="vsmPopupContent"><table><tr><th>Crew Member</th><th>Assigned Hours</th></tr>'
			+ vPopup + '</table></div><div class="vsmPopupOverlay"></div></div>');
		$('html, body').animate({ scrollTop: $(".vsmPopupContent").offset().top - 160 }, 'slow');
	},
	change: function (pWatch, pVoyage, pDate) {
		if (pWatch == 'Y') {
			var vDialog = '<div class="vsmSendToNc"><div class="vsmFormRegionHeader red">WARNING</div>'
				+ '<div class="sendToNcContent"><p>Please setup your crew watches in Step Watch Setup of Voyage Setup.</p></div></div>';
			$(vDialog).dialog({
				modal: true,
				resizable: false,
				width: 'auto',
				dialogClass: "vsmBtns",
				buttons: [{ text: "GO TO WATCH SETUP", click: function () { redirect('f?p=' + $v('pFlowId') + ':21:' + $v('pInstance') + '::NO::P21_DATE,P21_VOYAGE_ID:' + pDate + ',' + pVoyage) } }]
			});
		}
	},	
	toggleHour: function (e) {
		var vDivs, vFirst, vLast, vClicked = Number($(e.target).data("mins"));
		var vPrimary = $(e.target).closest("tr").hasClass("primary");
		if (!vPrimary || $(e.target).closest(".watchForm").hasClass("watchSchemaSetup")) {
			if (e.shiftKey) {
				$vDivs = $(e.target).parent().find("div");
				$vDivs.each(function () {
					if (($(this).hasClass("selected") || vClicked == Number($(this).data("mins"))) && !vFirst) vFirst = Number($(this).data("mins"));
					if ($(this).hasClass("selected")) vLast = Number($(this).data("mins"));
				});
				if (vLast < vClicked || vFirst < vClicked || !vLast) vLast = vClicked;
				$vDivs.each(function () {
					if (vFirst <= Number($(this).data("mins")) && vLast >= Number($(this).data("mins"))) $(this).addClass("selected");
					else $(this).removeClass("selected");
				});
			} else $(e.target).toggleClass("selected");
			if (!vms.watch.hrsItemVal($(e.target).parent(), vPrimary)) $(e.target).toggleClass("selected");
		}
	},
	hrsItemVal: function (pThis, pPrimary) {
		var vRet = "", vCnt = 0;
		$(pThis).find("div").each(function () {
			if ($(this).hasClass("selected")) { vRet += 'Y'; vCnt++; }
			else vRet += 'N';
		});
		if (pPrimary && !vms.watch.hrsGapCheck(vRet)) {
			alert("Hours of primary watch need to be grouped together without any gaps!");
			return false;
		} else if (!pPrimary && !vms.watch.hrsSecondaryCheck(pThis, vRet)) {
			alert("Hours of secondary watch need to be inside hours of its primary watch!");
			return false;
		} else {
			$(pThis).find("input").val(vRet);
			$(pThis).find(".hrsCnt > span").text(vCnt / 4);
			if (!$(pThis).closest("tr").hasClass("primary")) $(pThis).siblings("input[name=hours_tmp]").val("");
			vms.btn.hightlight("watchSubmitBtn");
			return true;
		}
	},	
	hrsGapCheck: function (pValue) {
		var hrs = pValue.substr(pValue.indexOf("Y", 0));
		var yLeng = hrs.replace(/N/g, "").length;
		return (yLeng < hrs.indexOf("N", 0) + 1 || hrs.indexOf("N", 0) == -1);
	},
	hrsSecondaryCheck: function (pThis, pHours) {
		var parentHours = "";
		/* get parent hours */
		parentHours = $(pThis).closest("tbody").find("tr.primary input[name=hours]").val();
		/* check for hours outside of primary hours */
		for (y = 0; y < parentHours.length; y++) {
			if (parentHours.substring(y, y + 1) == "N" && pHours.substring(y, y + 1) == "Y") return false;
		}
		return true;
	},	
	appendHours: function (pOriginal, pAppend) {
		var vHours = "";
		for (y = 0; y < pOriginal.length; y++) {
			//alert(y + " "+ pOriginal.substring(y,y+1) + pAppend.substring(y,y+1));
			if (pOriginal.substring(y, y + 1) == "Y" && pAppend.substring(y, y + 1) == "Y") vHours += "O";
			else if (pOriginal.substring(y, y + 1) == "O" || pAppend.substring(y, y + 1) == "O") vHours += "O";
			else if (pOriginal.substring(y, y + 1) == "Y" || pAppend.substring(y, y + 1) == "Y") vHours += "Y";
			else vHours += "N";
		}
		return vHours;
	},	
	addRow: function (pThis, pTempId) {		
		var vParent = $(pThis).closest("tbody").attr("pid");
		if (pThis && pTempId) {
			$(pThis).closest("tbody").append(watchRow.replace("#CLASS#", ' pid="' + vParent + '"'));
			vms.watch.setTemplate(pTempId, $(pThis).closest("tbody").find("tr:last-child .shiftTemplateDrop"));
		} else if (pThis) $(pThis).closest("tbody").append(watchRow.replace("#CLASS#", ' pid="' + vParent + '"'));
		else
			$(".watchForm > table").append('<tbody pid="0"><tr class="primaryHdr"><td colspan="5"><span onclick="vms.watch.addRow(this);">Add secondary</span></td></tr>' + watchRow.replace("#CLASS#", ' class="primary" pid=""') + "</tbody>");
		vms.btn.hightlight("watchSubmitBtn");		
		$("select[name='assigned']").select2();
		$("select[name='backup']").select2();
	},
	delRow: function (pId, pThis) {
		if (pId != 0) watchDeleteIds.push(pId);
		var $row = $(pThis).closest("tr");
		if ($row.hasClass("primary")) {
			$row.closest("tbody").remove();
		} else $row.remove();
		vms.btn.hightlight("watchSubmitBtn");
	},
    formPrimaryToggle: function(pThis) {
		$(pThis).closest("tr").toggleClass("primary");
    },
    checkPrimaryOverlap: function() {
		var primaryHours = [], vHour, vTempHour, vOverlapCnt = 0;
		$(".watchForm tr.primary input[name=hours]").each(function () { primaryHours.push(this.value); });
		if (primaryHours.length > 1) {
			for (x = 0; x < 96; x++) {
				vHour = primaryHours[0].substring(x, x + 1);
				for (y = 1; y < primaryHours.length; y++) {
					vTempHour = primaryHours[y].substring(x, x + 1);
					if (vHour == "Y" && vTempHour == "Y") vOverlapCnt++;
					else if (vHour == "N" && vTempHour == "Y") vHour = vTempHour;
				}
			}
		}
		return vOverlapCnt;
    },
    schemaForm: function(pSchemaId) {
		apex.server.process("watchSchemaForm"
			, { x01: pSchemaId }
			, {
				dataType: "html",
				success: function (pData) {
					$(".watchForm").html(pData);
					vms.btn.unhightlight("watchSubmitBtn");
					watchDeleteIds = [];
				}
			});
    },
    schemaSubmit: function() {
		var vOverlap, vRow, vRows = [], vData, vSchemaId = $("#watchSchemaId").val(), vPrimary;
		vOverlap = vms.watch.checkPrimaryOverlap();
		if (vOverlap > 0) {
			alert("Primary Watches have " + vOverlap + " hour(s) overlap, please review!");
			return;
		}

		$(".watchForm > table > tbody > tr:not(.primaryHdr)").each(function () {
			if ($(this).hasClass("primary")) vPrimary = 'P';
			else vPrimary = 'A';
			vRow = $(this).find("input[name=id]").val().replace("|", "").replace("~", "") + '|'
				+ $(this).find("input[name=name]").val() + '|'
				+ vPrimary + '|'
				+ $(this).find("input[name=hours]").val() + '|'
				+ $(this).attr("pid") + '|'
				+ $(this).find("input[name=seq]").val();
			vRows.push(vRow);
		});
		vData = vRows.join("~");
		vms.page.loading();
		apex.server.process("watchSchemaSubmit"
			, { x01: vSchemaId, x02: vData, x03: watchDeleteIds.join(":") }
			, {
				dataType: "html",
				success: function (pData) {
					$(".watchForm").replaceWith(pData);
					vms.btn.unhightlight("watchSubmitBtn");
					watchDeleteIds = [];
					vms.page.loadingRemove();
				}
			});
    },
	schemaChange: function (pSchemaItem, pDateItem, pProjectId) {
		if ($v("watchSchemaId") == $v(pSchemaItem)) null;
		else if (confirm("Shift schema change resets watches for current status! Are you sure you want to continue?"))
			apex.server.process("watchSchemaChange"
				, { x01: pProjectId, x02: $v(pSchemaItem) }
				, {
					dataType: "json",
					success: function (pData) {
						watchTemplates = pData.watchTemplates;
						$s("watchSchemaId", $v(pSchemaItem));
						vms.watch.form(pDateItem);
					}
				});
		else if ($v("watchSchemaId") != $v(pSchemaItem)) $s(pSchemaItem, $v("watchSchemaId"));
	}
};
